export default {
  contents: [
    {
      text: '(桂格)佳格食品股份有限公司（"佳格食品"或"我們"）致力於保護您的隱私並確保您的個人資料受到保護。就本隱私權政策目的而言，"個人資料"是指任何可藉此識別個人身份的資料，無論其是否屬實。'
    },
    {
      id: '1',
      title: '運用',
      text: '本隱私權政策說明我們蒐集的個人資料種類以及我們如何使用、揭露、傳輸、處理及保護這些資訊。我們以包括但不限於下列方式蒐集個人資料：\nA.當您瀏覽"本網站"時；\nB.當您經由社群媒體與我們聯繫參與我們的行銷活動時。\n\n我們會不時更新本隱私權政策。您繼續持造訪和/ 或使用本網站，將被視為您同意並接受每次更新版本所做的變更。請定期查看有關我們如何處理您個人資料的更新資訊。'
    },
    {
      id: '2',
      title: '同意',
      text: '我們不會未經您的同意而蒐集、使用或揭露您的個人資料（經法律允許及授權者除外）。當您向我們提供您的個人資料，您在此同意我們本隱私權政策第三條所列之目的蒐集、使用、揭露、傳輸及處理您的個人資料。我們蒐集您的個人資料種類包括但不限於：\n(a)姓名 ; (b) 手機; (c)電子郵件地址。為了提供下列第三條所定義的「本服務」，其他合理必要資訊。'
    },
    {
      id: '3',
      title: '目的',
      text: '我們為了提供服務而蒐集、使用、揭露、傳輸及處理您的個人資料。這些服務包括但不限於：\n1. 經由電子郵件、簡訊及郵件，提供我們及第三方業務合作夥伴的產品及活動資訊給您（如果我們取得您的明確同意）；\n2. 促進您與我們之間的交易；\n3. 通知您關於我們及我們服務的更新、變更及發展；\n4. 通知您關於本隱私權政策及我們其他政策或服務的重要變更；\n5. 回應您的疑問或反饋；\n6. 維護及運作本網站；\n7. 管理我們的行政或業務運作；\n8. 委任第三方業務夥伴及資訊處理者以提供本服務的部分內容；\n9. 進行客戶分析、市場分析和研究，以改進我們提供給您的產品和服務；\n10. 預防、偵測和調查犯罪及分析管理商業風險; 及\n11. 與上述內容合理相關的其他目的。\n（合稱「本服務」）'
    },
    {
      id: '4',
      title: '撤銷同意、取得及更正',
      text: '如果您想撤銷活動或任何其他本服務資訊的同意，您可以透過以下方式：\n1. 透過下方電子郵件地址；或2. 透過下方地址，寫信給我們。\n請注意，如果您選擇撤銷同意我們使用、揭露、傳輸及/ 或處理您的個人資料，我們可能無法向您提供部分或全部的本服務。我們將確保我們所掌握的個人資料，就我們所知，係準確且完整的。\n您有權要求取得和更正您的個人資料。如果您需要協助取得及 / 或更正您的個人資料，請透過下列電子郵件地址聯繫我們的資料維護人員。我們會在30天內回覆您。'
    },
    {
      id: '5',
      title: '向第三方揭露及傳輸',
      text: '除非我們已明確要求並得到您的同意，我們不會揭露或傳輸您的個人資料給第三方（但經法律允許及授權者，不在此限）。'
    },
    {
      id: '5.1',
      title: '向第三方業務合作夥伴揭露',
      text: '我們倚賴第三方業務合作夥伴代表我們提供各種服務。據此，本公司可能會讓位於台灣境內外的服務提供商將您的個人資料用於您可能感興趣的產品、服務或事件的行銷和推廣，以進行市場研究和分析、客戶關係管理及完成您透過網站購買產品和服務的訂單。請注意，我們僅向我們的關係企業和法律實體提供為了完成服務所需的個人資料，並要求其根據適用的法律和法規以及本隱私權政策保護這些個人資料，而不使用於任何其他目的。'
    },
    {
      id: '5.2',
      title: '向第三方資料處理者揭露',
      text: '我們可能會使用於第三方服務提供商，幫助我們維護和運作本網站，或其可能因為本網站運作和本公司業務的其他相關原因，而收到您的個人資料。我們僅向其提供為代表我們提供服務所需的個人資料，並要求其根據適用的法律和法規以及本隱私權政策保護個人資料，而不使用於任何其他目的。'
    },
    {
      id: '5.3',
      title: '其他揭露',
      text: '我們可能會使用和揭露您的個人資料以執行您的指示，以及下列相關事項(a)遵循法制和監管要求; (b)保護或維護本公司的顧客及員工的權利或財產; 和/或(c)為確保顧客、本公司或公眾的安全而採取緊急措施。'
    },
    {
      id: '6',
      title: '安全及維護',
      text: '我們以嚴格的程序、標準和安全措施，維護我們擁有或掌控的個人資料。無論透過實體或電子方式蒐集，一旦收到您的個人資料，我們都會做必要的安全措施，在合理且適當的情況下保護這些個人資料。這些措施可能包含行政措施、實體措施、技術措施或這些措施的結合。\n當透過網路揭露或傳輸您的個人資料時，我們會採取合理注意以防止他人未經授權而取得您的個人資料。但是，網路數據傳輸無法保證完全安全，您知悉透過網路提交資訊時，需自擔風險。'
    },
    {
      id: '7',
      title: '個人資料之保留',
      text: '我們只會在為了達到本隱私權政策目的及任何有效的商業或法律目的所需之時間內，保留您的個人資料。經過這段時間後，我們將以安全可靠的方式銷毀或匿名化包含您個人資料的任何文件。'
    },
    {
      id: '8',
      title: '準據法',
      text: '本隱私權政策以台灣法律為準據法。'
    },
    {
      id: '9',
      title: '行使權利',
      text: '佳格食品透過本活動蒐集、處理、利用您的個資於本活動相關事宜與佳格行銷使用。如涉法律訴訟等及相關主管機關要求時，將不在此限。您同意提供完整詳實之個資，若因您未更新或提供虛假資料致您的權益受損，由您自行負責，我們不負任何責任。您可依個資法第三條規定行使權利。行使前述權利時，我們將可能向您收取查詢、閱覽個資或製給複製本之必要成本費用。佳格可不定時修訂隱私權保護政策，並於官網張貼告示通知。'
    },
    {
      id: '10',
      title: '聯絡我們',
      text: '如果您想取得或更正您提供給我們的任何個人資料、提出投訴或對您的個人資料有任何疑問，請聯繫我們:\n佳格食品股份有限公司'
    }
  ],
  phone: '0800-006-600',
  email: 'mall@sfworldwide.com'
}